import Vue from 'vue';
import store from '../store';
import model from '@/app-model/index.js';
import appRunner from '@it-enterprise/web-app-runtime';
import auth from '@it-enterprise/jwtauthentication';
import router from '../router';
import { apolloClientClearCache } from '@/plugins/apollo';
import { registerDevice, unregisterDevice } from '@/plugins/push-notification';

Vue.use(appRunner, {
  store,
  auth,
  router,
  model,
});
Vue.$authEventBus.onBeforeSignIn(() => {
  store.commit('CLEAR_ERROR');
});
Vue.$authEventBus.onAfterSignIn(() => {
  // выполняется только после логина
});
Vue.$authEventBus.onSignInError((result) => {
  const message = (result.success === false ? result.errorMessage : null) || 'Ошибка авторизации';
  store.commit('SET_ERROR', message);
});
Vue.$authEventBus.onStartProcessing(() => {
  store.commit('SET_PROCESSING', true);
});
Vue.$authEventBus.onEndProcessing(() => {
  store.commit('SET_PROCESSING', false);
});
Vue.$authEventBus.onSignOut(() => {
  apolloClientClearCache();
  unregisterDevice();
});

Vue.$authCore.SetAdditionalUserDataHandler(async () => {
  // выполняется после логина и при аутентификации по токену
  await store.dispatch('SET_ADDITIONAL_DATA');

  if (store.getters.userGroup == store.getters.groupIdPm) {
    Vue.$authCore.SetUserRole('Admin');
  } else if (store.getters.userGroup == store.getters.groupIdPUser) {
    Vue.$authCore.SetUserRole('User');
  } else {
    Vue.$authCore.SetUserRole('Guest');
  }

  registerDevice();
});
